import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  OutlinedInput,
} from '@material-ui/core'

export default function LongNote(props) {
  const { longNote, setLongNote, showModal, hideModal } = props
  const [note, setNote] = useState('')

  useEffect(() => {
    setNote(longNote)
  }, [longNote])

  function updateLongNote() {
    setLongNote(note)
    close()
  }

  function close() {
    // setNote('')
    hideModal()
  }

  return (
    <Dialog
      open={showModal}
      onClose={close}
      disableBackdropClick
    >
      <DialogTitle id="alert-dialog-title">Add Note</DialogTitle>
      
      <DialogContent style={{ height: 500 }}>
        <OutlinedInput
          id='outlined-input'
          multiline  
          value={note}
          onChange={e => setNote(e.target.value)}
          rows={20}
          style={{ width: 400 }}
        />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={close} color="primary">Cancel</Button>
        <Button onClick={updateLongNote} color="primary" autoFocus disabled={note === ''}>Add Note</Button>
      </DialogActions>
    </Dialog>
  )
}